import { c as _c } from "react/compiler-runtime";
import { ICON_SMALL_STYLE, SphereAvatar } from "@components/header/sphere-avatar";
import { TEAM_AVATAR_BACKGROUND } from "@styles/common-colors";
import { Box } from "@mui-wrapper";
import { useAppSelector } from "@store/store-helper";
import { allTeamsSelector } from "@store/teams/teams-selector";
import { currentUserSelector } from "@store/user/user-selector";
import { TeamIcon, EmailIcon } from "@flat-ui";
import { withEllipsis } from "@styles/common-styles";
import { getPrettyName, getUserInitials } from "@utils/user-utils";
import { useMemo } from "react";
import { FaroCoreApiUtils } from "@stellar/core-api-client";

/**
 * Used to map the details of the current selection to something
 * that this component can show inside the box.
 */

// The width of the wrapper for the avatar in pixels.
const AVATAR_WIDTH = "60px";

/**
 * This component displays a user's avatar, name and email.
 */
export function UserDisplay(t0) {
  const $ = _c(43);
  const {
    member
  } = t0;
  const currentUser = useAppSelector(currentUserSelector);
  const teams = useAppSelector(allTeamsSelector);
  let t1;
  bb0: {
    if (member && FaroCoreApiUtils.Member.isTeam(member)) {
      let t2;
      if ($[0] !== member || $[1] !== teams) {
        let t3;
        if ($[3] !== member) {
          t3 = team => team.identity === member.identity;
          $[3] = member;
          $[4] = t3;
        } else {
          t3 = $[4];
        }
        t2 = teams.find(t3);
        $[0] = member;
        $[1] = teams;
        $[2] = t2;
      } else {
        t2 = $[2];
      }
      const item = t2;
      let t3;
      if ($[5] !== member) {
        t3 = getPrettyName(member);
        $[5] = member;
        $[6] = t3;
      } else {
        t3 = $[6];
      }
      const t4 = `${item?.memberCount} members`;
      let t5;
      if ($[7] !== t3 || $[8] !== t4) {
        t5 = {
          title: t3,
          subtitle: t4,
          type: "team"
        };
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
      } else {
        t5 = $[9];
      }
      t1 = t5;
      break bb0;
    }
    if (member && FaroCoreApiUtils.Member.isMemberActive(member)) {
      let t2;
      if ($[10] !== member) {
        t2 = getPrettyName(member);
        $[10] = member;
        $[11] = t2;
      } else {
        t2 = $[11];
      }
      const t3 = member.email;
      let t4;
      if ($[12] !== member) {
        t4 = getUserInitials(member);
        $[12] = member;
        $[13] = t4;
      } else {
        t4 = $[13];
      }
      let t5;
      if ($[14] !== member.email || $[15] !== member.thumbnailUrl || $[16] !== t2 || $[17] !== t4) {
        t5 = {
          title: t2,
          subtitle: t3,
          initials: t4,
          avatarSrc: member.thumbnailUrl,
          type: "member",
          avatarIcon: undefined
        };
        $[14] = member.email;
        $[15] = member.thumbnailUrl;
        $[16] = t2;
        $[17] = t4;
        $[18] = t5;
      } else {
        t5 = $[18];
      }
      t1 = t5;
      break bb0;
    }
    const t2 = member?.email ?? "";
    let t3;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <EmailIcon style={ICON_SMALL_STYLE} />;
      $[19] = t3;
    } else {
      t3 = $[19];
    }
    let t4;
    if ($[20] !== t2) {
      t4 = {
        title: t2,
        subtitle: undefined,
        initials: undefined,
        avatarSrc: undefined,
        avatarIcon: t3
      };
      $[20] = t2;
      $[21] = t4;
    } else {
      t4 = $[21];
    }
    t1 = t4;
  }
  const memberDetails = t1;
  let t2;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      height: "60px",
      display: "flex",
      alignItems: "center",
      width: "100%"
    };
    $[22] = t2;
  } else {
    t2 = $[22];
  }
  let t3;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: AVATAR_WIDTH
    };
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  let t4;
  if ($[24] !== currentUser?.id || $[25] !== member?.id || $[26] !== memberDetails.avatarIcon || $[27] !== memberDetails.avatarSrc || $[28] !== memberDetails.initials || $[29] !== memberDetails.type) {
    t4 = <Box component="div" sx={t3}>{memberDetails.type === "team" ? <SphereAvatar icon={<TeamIcon />} size="medium" backgroundColor={TEAM_AVATAR_BACKGROUND} /> : <SphereAvatar src={memberDetails.avatarSrc} initials={memberDetails.initials ?? ""} icon={memberDetails.avatarIcon} size="medium" shouldUseSimplifiedAvatar={currentUser?.id !== member?.id} />}</Box>;
    $[24] = currentUser?.id;
    $[25] = member?.id;
    $[26] = memberDetails.avatarIcon;
    $[27] = memberDetails.avatarSrc;
    $[28] = memberDetails.initials;
    $[29] = memberDetails.type;
    $[30] = t4;
  } else {
    t4 = $[30];
  }
  let t5;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      fontSize: "14px",
      color: "text.primary",
      width: `calc(100% - ${AVATAR_WIDTH})`
    };
    $[31] = t5;
  } else {
    t5 = $[31];
  }
  let t6;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      ...withEllipsis
    };
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  let t7;
  if ($[33] !== memberDetails.title) {
    t7 = <Box component="div" sx={t6}><var>{memberDetails.title}</var></Box>;
    $[33] = memberDetails.title;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  let t8;
  if ($[35] !== memberDetails.subtitle) {
    t8 = memberDetails.subtitle && <Box component="div" sx={{
      ...withEllipsis
    }}><var>{memberDetails.subtitle}</var></Box>;
    $[35] = memberDetails.subtitle;
    $[36] = t8;
  } else {
    t8 = $[36];
  }
  let t9;
  if ($[37] !== t7 || $[38] !== t8) {
    t9 = <Box component="div" sx={t5}>{t7}{t8}</Box>;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
  } else {
    t9 = $[39];
  }
  let t10;
  if ($[40] !== t4 || $[41] !== t9) {
    t10 = <Box component="div" sx={t2}>{t4}{t9}</Box>;
    $[40] = t4;
    $[41] = t9;
    $[42] = t10;
  } else {
    t10 = $[42];
  }
  return t10;
}